import { styled } from '@mui/material/styles'
import { HEADER_HT } from '../../constants'
import Dialog from '@mui/material/Dialog'

const PREFIX = 'Header'
const MOBILE_MENU_ITEM_HT = 100

// Global Styles
const globalBtn = {
  maxHeight: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  minWidth: 'fit-content',
  paddingRight: 8,
  paddingLeft: 8,
}

const globalBtnText = (theme) => ({
  paddingTop: 3,
  fontSize: 10,
  [theme.breakpoints.down('md')]: {
    paddingTop: 0,
    fontSize: 10,
  },
})

const globalSignInAlready = (theme) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: -1,
  },
})

const globalBtnSignIn = (theme) => ({
  marginRight: 8,
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
})

const globalSignInBtnText = (theme) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: 6,
  },
})

export const classes = {
  root: `${PREFIX}-root`,
  root_mobile: `${PREFIX}-root_mobile`,
  atClientRoot: `${PREFIX}-atClientRoot`,
  atSiteplanPageRoot: `${PREFIX}-atSiteplanPageRoot`,
  menuButtonBase: `${PREFIX}-menuButtonBase`,
  menuButton: `${PREFIX}-menuButton`,
  menuButtonDisabled: `${PREFIX}-menuButtonDisabled`,
  mainHeader: `${PREFIX}-mainHeader`,
  clientRootSubheader: `${PREFIX}-clientRootSubheader`,
  subHeader: `${PREFIX}-subHeader`,
  subHeaderFp: `${PREFIX}-subHeaderFp`,
  loadingContainer: `${PREFIX}-loadingContainer`,
  atPlansPage: `${PREFIX}-atPlansPage`,
  btn: `${PREFIX}-btn`,
  btnSignIn: `${PREFIX}-btnSignIn`,
  btnSignInAlready: `${PREFIX}-btnSignInAlready`,
  btnText: `${PREFIX}-btnText`,
  signInBtnText: `${PREFIX}-signInBtnText`,
  avatar: `${PREFIX}-avatar`,
  icon: `${PREFIX}-icon`,
  iconContainer: `${PREFIX}-iconContainer`,
  leftGrpContainer: `${PREFIX}-leftGrpContainer`,
  rightGrpContainer: `${PREFIX}-rightGrpContainer`,
  mainGrpContainer: `${PREFIX}-mainGrpContainer`,
  favoritesMainGrpContainer: `${PREFIX}-favoritesMainGrpContainer`,
  link: `${PREFIX}-link`,
  logo: `${PREFIX}-logo`,
  mainMenuIconButton: `${PREFIX}-mainMenuIconButton`,
  iconButtonText: `${PREFIX}-iconButtonText`,
  commName: `${PREFIX}-commName`,
  mobileMenuIcon: `${PREFIX}-mobileMenuIcon`,
  inventoryHomeWithZeroPrice: `${PREFIX}-inventoryHomeWithZeroPrice`,
}

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: `${HEADER_HT}px 1px ${HEADER_HT - 1}px`,
    gridTemplateAreas: `"mainHeader" "divider" "subHeader"`,
    background: 'transparent',
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: `${HEADER_HT}px 1px 4px`,
    },
    userSelect: 'none',
    '& div': {
      userSelect: 'none',
    },
    pointerEvents: 'none',
  },

  [`& .${classes.root_mobile}`]: {
    gridTemplateRows: '1fr',
    gridTemplateAreas: `"mainHeader"`,
  },

  [`& .${classes.atClientRoot}`]: {
    gridTemplateRows: '1fr',
    gridTemplateAreas: `"mainHeader"`,
  },

  [`& .${classes.atSiteplanPageRoot}`]: {
    gridTemplateRows: `1fr`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  [`& .${classes.menuButtonBase}`]: {
    width: 160,
  },

  [`& .${classes.menuButton}`]: {
    fontSize: '1.25rem',
  },

  [`& .${classes.menuButtonDisabled}`]: {
    color: '#DADADA',
  },

  [`& .${classes.mainHeader}`]: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '100vw',
    width: 'inherit',
    gridArea: 'mainHeader',
    display: 'grid',
    height: HEADER_HT,
    maxHeight: HEADER_HT,
    overflow: 'hidden',
    gridTemplateColumns: '120px 1fr 200px',
    gridTemplateRows: '1fr',
    gridTemplateAreas: '"leftGrp mainGrp rightGrp"',
    backgroundColor: 'white',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '60px 1fr 1fr',
    },
    pointerEvents: 'all',
  },

  [`& .${classes.clientRootSubheader}`]: {
    height: 0,
  },

  [`& .${classes.subHeader}`]: {
    position: 'relative',
    gridArea: 'subHeader',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
    gridTemplateColumns: '120px 1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: `"leftSub midSub"`,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      gridTemplateAreas: `"midSub"`,
      gridTemplateColumns: '1fr',
    },
  },

  [`& .${classes.subHeaderFp}`]: {
    [theme.breakpoints.down('sm')]: {
      gridTemplateAreas: `"midSub rightSub"`,
    },
  },

  [`& .${classes.loadingContainer}`]: {
    height: 35,
    width: 35,
  },

  [`& .${classes.atPlansPage}`]: {
    gridTemplateAreas: `"midSub"`,
    gridTemplateColumns: '1fr',
  },

  [`& .${classes.btnSignInAlready}`]: {
    ...globalSignInAlready(theme),
  },

  [`& .${classes.btn}`]: {
    ...globalBtn,
  },

  [`& .${classes.btnText}`]: {
    ...globalBtnText(theme),
    paddingTop: 0,
  },

  [`& .${classes.avatar}`]: {
    width: 36,
    height: 36,
  },

  [`& .${classes.icon}`]: {
    fontSize: 36,
    color: theme.palette.primary.light,
  },

  [`& .${classes.iconContainer}`]: {
    marginTop: 4,
    marginBottom: 6,
    [theme.breakpoints.down('lg')]: {
      marginTop: 3,
      marginBottom: 1,
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      '& svg': {
        height: 30,
        marginTop: -8,
      },
    },
  },

  [`& .${classes.leftGrpContainer}`]: {
    maxHeight: '100%',
    gridArea: 'leftGrp',
    height: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },

  [`& .${classes.rightGrpContainer}`]: {
    gridArea: 'rightGrp',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  [`& .${classes.mainGrpContainer}`]: {
    gridArea: 'mainGrp',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },

  [`& .${classes.favoritesMainGrpContainer}`]: {
    gridArea: 'mainGrp',
    display: 'flex',
    flexDirection: 'row',
  },

  [`& .${classes.link}`]: {
    padding: 8,
    height: '80%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`& .${classes.logo}`]: {
    width: '100%',
    height: '100%',
    maxWidth: '40vw',
    maxHeight: '100%',
    objectFit: 'contain',
    paddingLeft: 10,
  },

  [`& .${classes.mainMenuIconButton}`]: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },

  [`& .${classes.iconButtonText}`]: {
    fontSize: 10,
    [theme.breakpoints.down('md')]: {
      fontSize: 8,
    },
  },

  [`& .${classes.commName}`]: {
    fontSize: 16,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 280,
    overflow: 'hidden',
  },

  [`& .${classes.inventoryHomeWithZeroPrice}`]: {
    fontSize: 13,
    textAlign: 'center',
    display: 'block',
  },

  [`& .${classes.mobileMenuIcon}`]: {
    height: '50%',
    maxWidth: '40vw',
    objectFit: 'contain',
    marginTop: 5,
  },
}))

export const StyledSystemInfoDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    padding: 15,
  },
}))

export const StyledSystemInfoText = styled('span')(() => ({
  marginBottom: 5,
}))

const PREFIX_MOBILE_MENU = 'Header-Mobile-Menu'
export const mobileMenuClasses = {
  appBar: `${PREFIX_MOBILE_MENU}-appBar`,
  mobileMenuItemContainer: `${PREFIX_MOBILE_MENU}-mobileMenuItemContainer`,
  mobileMenuItem: `${PREFIX_MOBILE_MENU}-mobileMenuItem`,
  mobileMenuIconContainer: `${PREFIX_MOBILE_MENU}-mobileMenuIconContainer`,
  closeBtn: `${PREFIX_MOBILE_MENU}-closeBtn`,
  dlgTitle: `${PREFIX_MOBILE_MENU}-dlgTitle`,
  btnSignIn: `${PREFIX_MOBILE_MENU}-btnSignIn`,
  btnSignInAlready: `${PREFIX_MOBILE_MENU}-btnSignInAlready`,
  signInBtnText: `${PREFIX_MOBILE_MENU}-signInBtnText`,
  btn: `${PREFIX_MOBILE_MENU}-btn`,
  btnText: `${PREFIX_MOBILE_MENU}-btnText`,
}

export const StyledMobileMenuDialog = styled(Dialog)(({ theme }) => ({
  [`& .${mobileMenuClasses.appBar}`]: {
    position: 'relative',
  },
  [`& .${mobileMenuClasses.mobileMenuItemContainer}`]: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  },

  [`& .${mobileMenuClasses.mobileMenuItem}`]: {
    height: MOBILE_MENU_ITEM_HT,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  [`& .${mobileMenuClasses.mobileMenuIconContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: MOBILE_MENU_ITEM_HT,
    width: MOBILE_MENU_ITEM_HT,
  },

  [`& .${mobileMenuClasses.closeBtn}`]: {
    position: 'absolute',
    right: 0,
    marginRight: 16,
  },

  [`& .${mobileMenuClasses.dlgTitle}`]: {
    margin: '0 auto', // centered
  },

  [`& .${mobileMenuClasses.signInBtnText}`]: {
    ...globalSignInBtnText(theme),
  },

  [`& .${mobileMenuClasses.btnSignIn}`]: {
    ...globalBtnSignIn(theme),
  },

  [`& .${mobileMenuClasses.btnSignInAlready}`]: {
    ...globalSignInAlready(theme),
  },

  [`& .${mobileMenuClasses.btn}`]: {
    ...globalBtn,
  },

  [`& .${mobileMenuClasses.btnText}`]: {
    ...globalBtnText(theme),
  },
}))

const PREFIX_MAIN_MENU_BUTTON = 'Header-Main-Menu-Button'
export const mainMenuButton = {
  svgLine: `${PREFIX_MAIN_MENU_BUTTON}-svgLine`,
  menuText: `${PREFIX_MAIN_MENU_BUTTON}-menuText`,
}

export const StyledMainMenuButton = styled('div')(({ theme }) => ({
  width: 300,
  cursor: 'pointer',
  textTransform: 'uppercase',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('lg')]: {
    width: 120,
  },
  [theme.breakpoints.down('sm')]: {
    width: 200,
    alignItems: 'center',
  },

  [`& .${mainMenuButton.menuText}`]: {
    fontFamily: 'Roboto, serif',
    fontWeight: 700,
    letterSpacing: '0.23rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: 14,
    },
  },

  [`& .${mainMenuButton.svgLine}`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    strokeDasharray: 280,
    strokeDashoffset: 280,
    '&:hover': {
      animation: 'forwardOffset 0.25s linear forwards',
    },
  },
}))

export const SubheaderDiv = styled('div')(({ atPlanPage }) => ({
  pointerEvents: atPlanPage ? 'none' : 'auto',
}))

export default Root
